<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 01:36:00
    Description :
  -->
  <div>
    <el-dialog
      title="上传素材"
      custom-class="material-upload"
      :visible.sync="uploadDialogVisible"
      width="600px"
    >
      <div v-loading="loading">
        <h4>请选择上传类型</h4>
        <div
          style="
            margin-top: 10px;
            color: #999999;
            font-size: 14px;
            line-height: 20px;
          "
        >
          <div>
            该入口仅用于
            <b style="font-weight: bold; color: #333333"> 上传素材 </b>
            文件,
          </div>
          <div>其它类型的文件请进入对应主页上传通道进行上传。</div>
        </div>
        <div class="item">
          <el-radio v-model="type" :label="0">共享 (免费) 素材</el-radio>
          <el-radio v-model="type" :label="1">出售 (付费) 素材</el-radio>
        </div>
        <div class="list-item">
          <el-button
            @click="jumpTo('/video-upload')"
            style="background: #ededed"
          >
            视频素材
          </el-button>
          <el-button
            @click="jumpTo('/picture-upload')"
            style="background: #ededed"
          >
            图片素材
          </el-button>
          <el-button
            @click="jumpTo('/music-upload')"
            style="background: #ededed"
          >
            音频素材
          </el-button>
          <el-button
            @click="jumpTo('/template-upload')"
            style="background: #ededed"
          >
            模板素材
          </el-button>
          <el-button
            @click="jumpTo('/virtual-upload')"
            style="background: #ededed"
           >
            虚拟资产素材
          </el-button>
          <el-button
            @click="jumpTo('/other-upload')"
            style="background: #ededed; margin-left: -1px;"
          >
            其它素材
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { checkVerified } from "@/api/upload";
export default {
  data() {
    return {
      loading: true,
      uploadDialogVisible: false,
      type: 0,
      msg: "",
    };
  },
  watch: {
    uploadDialogVisible(e) {
      if (e) {
        this.checkVerified();
      }
    },
    type(new_v, old_v) {
      const msg = this.msg;
      let content = "";
      if (new_v == 1 && new_v !== old_v) {
        if (msg === "not.verified") {
          content = "出售付费素材需要实名认证, 是否前往认证？";
        } else if (msg === "waitting") {
          this.$message.warning("认证审核中, 请耐心等待");
          this.type = 0;
        } else if (msg === "notPass") {
          content = "认证未通过, 是否重新认证？";
        } else if (msg === "pass") {
          console.log("已认证");
        } else {
          this.$message.error("未知错误");
          this.type = 0;
        }
        if (content) {
          this.$confirm(content)
            .then((_) => {
              this.$router.push("/gaia-material/check-verified");
              this.uploadDialogVisible = false;
            })
            .catch((_) => {
              this.type = 0;
            });
        }
      }
    },
  },
  methods: {
    show() {
      this.uploadDialogVisible = true;
    },
    checkVerified() {
      this.loading = true;
      checkVerified()
        .then(({ msg }) => {
          this.msg = msg;
          if (msg === "not.verified") {
            console.log("未认证");
          } else if (msg === "pass") {
            console.log("已认证");
          } else if (msg === "waitting") {
            console.log("审核中");
          } else if (msg === "notPass") {
            console.log("未通过认证");
          }
          // this.$route.push(`${path}`);
          this.loading = false;
        })
        .catch((res) => {
          this.loading = false;
          this.$message.error("请检查网络");
        });
    },
    jumpTo(path) {
      this.uploadDialogVisible = false;
      if (this.$route.path == `/gaia-material${path}`) {
        return;
      }
      this.$router.push({
        path: `/gaia-material${path}`,
        query: {
          allowDownload: this.type,
        },
      });
    },
  },
};
</script>
<style lang="less">
.material-upload {
  .el-dialog__header {
    border-bottom: 3px #ff4f57 solid;
    margin: 0 20px;
  }
}
</style>
<style lang="less" scoped>
.item {
  margin: 20px 0;
}

.list-item {
    display: flex;
    flex-wrap: wrap;
    justify-content: start;
    align-items: start;
    row-gap: 10px;
}
</style>
